import { render, staticRenderFns } from "./AppFun.vue?vue&type=template&id=5401d8d5&scoped=true"
import script from "./AppFun.vue?vue&type=script&lang=js"
export * from "./AppFun.vue?vue&type=script&lang=js"
import style0 from "./AppFun.vue?vue&type=style&index=0&id=5401d8d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5401d8d5",
  null
  
)

export default component.exports